// Icons for Global Covid Cases
import iconCovidGlobalConfirmed from "./Component/Assets/icon-covid-global-confirmed.svg";
import iconCovidGlobalRecovered from "./Component/Assets/icon-covid-global-recovered.svg";
import iconCovidGlobalActive from "./Component/Assets/icon-covid-global-active.svg";
import iconCovidGlobalDeceased from "./Component/Assets/icon-covid-global-deceased.svg";

// Icons for Symptoms
import iconSymptomsDifficultyBreathing from "./Component/Assets/icon-symptoms-difficulty-breathing.svg"
import iconSymptomsDryCough from "./Component/Assets/icon-symptoms-dry-cough.svg"
import iconSymptomsFever from "./Component/Assets/icon-symptoms-fever.svg"
import iconSymptomsSoreThroat from "./Component/Assets/icon-symptoms-sore-throat.svg"

const COVID_DECLARATION_GLOBAL_STATS = [
    {
        className: "hsg-dashboard-covid-overall-numbers-width padding-right-0",
        label: "Confirmed",
        key: "confirmed",
        icon: iconCovidGlobalConfirmed,
        iconBackground: {
            background: "rgba(255, 0, 0, 0.3)",
            borderRadius: 4,
        },
    },
    {
        className: "hsg-dashboard-covid-overall-numbers-width padding-right-0",
        label: "Active",
        key: "active",
        icon: iconCovidGlobalActive,
        iconBackground: {
            background: "rgba(0, 145, 255, 0.3)",
            borderRadius: 4,
        },
    },
    {
        className: "hsg-dashboard-covid-overall-numbers-width padding-right-0",
        label: "Recovered",
        key: "recovered", 
        icon: iconCovidGlobalRecovered,
        iconBackground: {
            background: "rgba(0, 172, 90, 0.3)",
            borderRadius: 4,
        },
    },
    {
        className: "hsg-dashboard-covid-overall-numbers-width padding-right-0",
        label: "Deceased",
        key: "deceased",
        icon: iconCovidGlobalDeceased,
        iconBackground: {
            background: "rgba(82, 93, 125, 0.3)",
            borderRadius: 4,
        },
    },
];

const COVID_DECLARATION_SYMPTOMS = [
    {
        className: "col-xs-12 padding-0",
        label: "Fever",
        key: "percentageFever",
        icon: iconSymptomsFever
    },
    {
        className: "col-xs-12 padding-0",
        label: "Dry Cough",
        key: "percentageCough",
        icon: iconSymptomsDryCough
    },
    {
        className: "col-xs-12 padding-0",
        label: "Difficulty Breathing",
        key: "percentageBreathing",
        icon: iconSymptomsDifficultyBreathing
    },
    {
        className: "col-xs-12 padding-0",
        label: "Sore Throat",
        key: "percentageThroat",
        icon: iconSymptomsSoreThroat
    },
]

const URL_COVID_DASHBOARD_REF = "https://www.covid19india.org/";

const STRING_GLOBAL_STATS_VIEW_MORE = "More Stats";
const STRING_SYMPTOMS_HEADING = "HealthSetGo Symptom Analysis";
const STRING_SYMPTOMS_SUB_HEADING = "% of population reporting Covid Symptoms today";
const STRING_LIVE_UPDATES = "LIVE UPDATES"

export default {
    COVID_DECLARATION_GLOBAL_STATS,
    COVID_DECLARATION_SYMPTOMS,

    URL_COVID_DASHBOARD_REF,
    
    STRING_GLOBAL_STATS_VIEW_MORE,
    STRING_SYMPTOMS_HEADING,
    STRING_SYMPTOMS_SUB_HEADING,
    STRING_LIVE_UPDATES
}
